import HTMLTemplate from './template.html'
import draggable from 'vuedraggable'
import { DetailsPanel } from '../DetailsPanel/DetailsPanel'
import { Compare } from '../Compare/Compare'
import MapBox from '../../modules/map'
import { some } from 'lodash'
import './styles.scss'
import User from '../../modules/user'
import Airport from '../../modules/airport'
import { getAirportDetailProperties } from '../../services/AirportService'
import MixPanelService from '../../services/MixPanelService'

export const AirportPins = (() => {
    const vueComponent = {
        components: {
            draggable
        },
        data() {
            return {
                pinnedAirports: [],
                activePinnedAirportICAO: null,
                drag: false,
                userAirportCodePreference: 'ICAO'
            }
        },
        created() {
            User.getLocalUserSettings().then(userSettings => {
                if (userSettings.pinnedElements.length > 0) {
                    let userPinnedAirportICAOCodes = userSettings.pinnedElements
                    if (typeof userSettings.pinnedElements[0] === 'object') {
                        // Here we are in presence of user settings with the old system where we used to store the whole object
                        // of tha basic airport details. That approach was bad because it was making the user settings much bigger
                        // and it was saving fixed ratings for that airport, so if any of them were updated it won't reflect in
                        // pinned airports. Create a simple array of ICAO codes as it should be and proceed with the rest.
                        // We are going to leave a console message, so it can be tracked and this code can be removed
                        // once the message won't be appearing in the reporting anymore.
                        console.warn('Detected old user pinned airport settings. This is going to be fixed on fly and should not appear for the user anymore.')
                        userPinnedAirportICAOCodes = []
                        userSettings.pinnedElements.forEach(pinnedAirportDetails => {
                            userPinnedAirportICAOCodes.push(pinnedAirportDetails.icao)
                        })

                        this.saveUserPinnedAirports(userPinnedAirportICAOCodes)
                    }

                    this.pinAirportDetails(userPinnedAirportICAOCodes)
                }
            })
        },
        mounted() {
            // Observe if the airport module was closed, in that case deactive any active pins
            const appTemplate = document.getElementsByClassName('app-template')[0]
            const observer = new MutationObserver(() => {
                if (!appTemplate.classList.contains('details-panel-show')) this.activePinnedAirportICAO = null
            })

            observer.observe(appTemplate, { attributes: true, attributeFilter: ['class'] })

            this.subscribeToUserSettingsChanges()
        },
        methods: {
            subscribeToUserSettingsChanges() {
                window.setInterval(() => this.userAirportCodePreference = User.userSettings.airportCode, 2500)
            },
            pinAirportDetails(airportICAOCodes) {
                let airportDetailsToPin = []
                Airport.getModuleReadyStatus().then(() => {
                    airportICAOCodes.forEach(ICAOCode => {
                        const airportBasicDetails = Airport.getAirportByICAOCode(ICAOCode)

                        if (!!airportBasicDetails) {
                            airportDetailsToPin.push(getAirportDetailProperties(airportBasicDetails))
                        }
                    })

                    this.pinnedAirports = airportDetailsToPin
                })
            },
            addAirport(ICAOCode) {
                const existingAirportCodes = this.pinnedAirports.map(airportDetails => airportDetails.icao)
                let userPinnedAirportICAOCodes = existingAirportCodes.concat(ICAOCode)
                this.pinAirportDetails(userPinnedAirportICAOCodes)
                this.saveUserPinnedAirports(userPinnedAirportICAOCodes)
            },
            removeAirport(ICAOCode) {
                const airportIndex = this.pinnedAirports.findIndex(airport => {
                    return airport.icao === ICAOCode
                })

                this.pinnedAirports.splice(airportIndex, 1)
                this.saveUserPinnedAirports(this.pinnedAirports)
            },
            saveUserPinnedAirports(userPinnedAirportICAOCodes) {
                User.getLocalUserSettings().then(userSettings => {
                    userSettings.pinnedElements = userPinnedAirportICAOCodes
                    User.updateUserSettings(userSettings)
                })
            },
            isAirportPinned(ICAOCode) {
                return some(this.pinnedAirports, ['icao', ICAOCode])
            },
            getAirportDate(ICAOCode) {
                return this.pinnedAirports.find((airport) => {
                    return airport.icao === ICAOCode
                })
            },
            findAirportIndex(ICAOCode) {
                return this.pinnedAirports.findIndex((airport) => {
                    return airport.icao === ICAOCode
                })
            },
            openAiport(ICAOCode) {
                this.activePinnedAirportICAO = ICAOCode
                const airportDetails = this.getAirportDate(ICAOCode)

                MapBox.map.jumpTo({
                    center: [airportDetails.longitude, airportDetails.latitude],
                    zoom: 8
                });

                DetailsPanel.showDetailsPanel(airportDetails)
            },
            openPreviousPinnedItem() {
                const currentIndex = this.findAirportIndex(this.activePinnedAirportICAO)
                let previousAirportICAO = null

                if (currentIndex > 0) {
                    previousAirportICAO = this.pinnedAirports[currentIndex - 1].icao
                    this.openAiport(previousAirportICAO)
                }
            },
            openNextPinnedItem() {
                const currentIndex = this.findAirportIndex(this.activePinnedAirportICAO)
                let nextAirportICAO = null

                if (currentIndex < this.pinnedAirports.length - 1) {
                    nextAirportICAO = this.pinnedAirports[currentIndex + 1].icao
                    this.openAiport(nextAirportICAO)
                }
            },
            clearPins() {
                if (window.confirm('Warning: This action will clear your pinned airports. Are you sure you wish to continue?')) {
                    this.pinnedAirports = []
                    this.saveUserPinnedAirports(this.pinnedAirports)
                }
            },
            onDragEnd() {
                this.drag = false
                // We need to save again user pinned airports to preserve sorted order
                this.saveUserPinnedAirports(this.pinnedAirports)
            },
            onDragStart() {
                this.drag = true
            },
            compare() {
                const airportToAdd = this.pinnedAirports.map(airport => airport.icao)
                MixPanelService.track('Page View - Compare', {
                    'Clicked Location': 'Airports Pins',
                    'ICAO': airportToAdd.join(', '),
                    'Airports': this.pinnedAirports?.map(res => {
                        return {
                            'Clicked Location': 'Details Panel',
                            'Airport Name': res?.airportName || '',
                            'ICAO': res?.icao || '',
                            'IATA': res?.iata || '',
                            'Country': res?.country || '',
                            'Country Code': res?.countryCode3 || '',
                            'City': res?.cityName || ''
                        }
                    })
                })
                Compare.addAirports(airportToAdd)
                Compare.show()
            },
            checkIfMobileDevice() {
                let details = navigator.userAgent;
                let regexp = /android|iphone|iPad|iPod|kindle|ipad/i;

                /* Using test() method to search regexp in details
                it returns boolean value*/
                let isMobileDevice = regexp.test(details);
                return isMobileDevice
            }
        },
        computed: {
            dragOptions() {
                let isDisabled = this.checkIfMobileDevice() || false
                return {
                    animation: 400,
                    group: 'description',
                    disabled: isDisabled,
                    ghostClass: 'ghost'
                }
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-airport-pins')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();
